'use strict'
import { default as axios } from 'axios'
import notify from "@/utils/notify";
import {decrypt} from "@/utils/crypto";

export default {

  async api(data, token = null) {
    if (token === null) {
      token = decrypt(sessionStorage.getItem('access_token'))
    }
    const AUTH_TOKEN = `Bearer ${token}`

    axios.defaults.baseURL = process.env.VUE_APP_API_URL
    axios.defaults.headers.common['Authorization'] = AUTH_TOKEN
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    axios.defaults.headers.common['Accept'] = 'application/json'
    // axios.defaults.withCredentials = true

    try {
      const response = await axios({
        method: data.method,
        url: data.url,
        data: data.body,
      })

      return {
        status: response.status,
        data: response.data,
      }
    } catch (error) {
      if (error.response) {
        console.log(error)
        // Handle different HTTP status codes
        switch (error.response.status) {
          case 400:
            notify.alert.error('Bad Request: The server could not process your request.')
            break
          case 401:
            notify.alert.error('Unauthorized: Please log in again to continue.')
            sessionStorage.clear()
            break
          case 403:
            notify.alert.error('Forbidden: You do not have permission to access this resource.')
            break
          case 404:
            // Just return empty array for 404 without notification
            return []
          case 422:
            // Format validation errors in a more user-friendly way
            let message = ''
            if ('errors' in error.response.data) {
              let errors = error.response.data.errors
              // Create a formatted list of errors
              message = '<ul style="text-align: left; margin: 0; padding-left: 20px;">'
              for (const key in errors) {
                message += `<li>${errors[key]}</li>`
              }
              message += '</ul>'
            } else {
              message = error.response.data.message
            }
            notify.alert.error(message)
            break
          case 500:
            notify.alert.error('Server Error: Something went wrong on our end. Please try again later.')
            break
          case 503:
            notify.alert.error('Service Unavailable: The server is temporarily unavailable. Please try again later.')
            break
          default:
            notify.alert.error(`Error ${error.response.status}: ${error.response.data.message || 'Something went wrong. Please try again.'}`)
        }

        return {
          status: error.response.status,
          data: error.response.data,
        }
      } else if (error.request) {
        sessionStorage.clear();
        notify.alert.error('Network Error: Unable to connect to the server. Please check your internet connection and try again.')
      } else {
        notify.alert.error('An unexpected error occurred. Please try again or contact support if the issue persists.')
      }
      console.log(error)
      return []
    }
  },
}
